
const messages = {
    en: {
       delivery: {
          dailyBox: { 
            name: 'DailyBox',
            title: 'DailyBox management',
            subtitle: 'View, search, create, edit and delete DailyBox',
            creating: 'Creating DailyBox',
            editing: 'Editing DailyBox',
            deleting: 'Deleting DailyBox',
            showing: 'Showing DailyBox',
            menu: 'DailyBox',
            labels: {
                boxDate: 'Concept',
                shift: 'Shift',
                rows: 'Rows'
            },
          
          }
       }
    },
    es: {
       delivery: {
          dailyBox: { 
            name: 'DailyBox',
            title: 'Administración de DailyBox',
            subtitle: 'Ver, buscar, crear, editar, y borrar DailyBox',
            creating: 'Creando DailyBox',
            editing: 'Modificando DailyBox',
            deleting: 'Eliminando DailyBox',
            showing: 'Detalles de DailyBox',
            menu: 'DailyBox',
            labels: {
                boxDate: 'Concepto',
                shift: 'Turno',
                rows: 'Registros'
            },
          
          }
       }
    },
    pt: {
       delivery: {
          dailyBox: { 
            name: 'DailyBox',
            title: 'Administração de DailyBox',
            subtitle: 'Ver, buscar, criar, editar e usar DailyBox',
            creating: 'Criando DailyBox',
            editing: 'Edição DailyBox',
            deleting: 'Apagando DailyBox',
            showing: 'Detalhes do DailyBox',
            menu: 'DailyBox',
            labels: {
                boxDate: 'Concepto',
                shift: 'Turno',
                rows: 'Registros'
            },
          
          }
       }
    }
}

export default messages
    